import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroller vers le haut au changement de page
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const ScrollToHash = () => {
  const { hash, search } = useLocation();

  useEffect(() => {
    // Gérer les query params pour le scroll
    const params = new URLSearchParams(search);
    const scrollTo = params.get('scroll');
    
    if (scrollTo) {
      setTimeout(() => {
        const element = document.getElementById(scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else if (hash) {
      // Enlever le '#' du hash
      const id = hash.replace('#', '');
      
      // Attendre un peu pour que le DOM soit prêt
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [hash, search]);

  return null;
};

export default ScrollToTop;
